import React from "react";
import Dashboard from "../pages/Dashboard/Dashboard";
import StudentsListPage from "../pages/Students/StudentsListPage";
import StudentReportsPage from "../pages/Students/StudentReportsPage";
import StudentMultipleRegistrationPage from "../pages/Students/StudentMultipleRegistrationPage";
import StudentMigrationPage from "../pages/Students/StudentMigrationPage";
import StudentMigrationPushbackPage from "../pages/Students/StudentMigrationPushbackPage";
import StudentExcelRegistrationWithIdPage from "../pages/Students/StudentExcelRegistrationWithIdPage";
import StudentExcelRegistrationWithoutIdPage from "../pages/Students/StudentExcelRegistrationWithoutIdPage";
import StaffListPage from "../pages/Staff/StaffListPage";
import StaffMultipleUpdatePage from "../pages/Staff/StaffMultipleUpdatePage";
import StaffFormPage from "../pages/Staff/StaffFormPage";
import StaffExcelRegistrationPage from "../pages/Staff/StaffExcelRegistrationPage";
import ClassTeacherAssignPage from "../pages/Staff/ClassTeacherAssignPage";
import ShiftTeacherAssignPage from "../pages/Staff/ShiftTeacherAssignPage";
import SubjectAssignToTeacherPage from "../pages/Staff/SubjectAssignToTeacherPage";
import DefaultSignaturePage from "../pages/Staff/DefaultSignaturePage";
import ClassTeacherSignaturePage from "../pages/Staff/ClassTeacherSignaturePage";
import StudentAttendanceTakePage from "../pages/Attendance/StudentAttendanceTakePage";
import StudentDailySectionReportPage from "../pages/Attendance/StudentDailySectionReportPage";
import StudentMonthlySummaryPage from "../pages/Attendance/StudentMonthlySummaryPage";
import StudentMonthlyDetailsPage from "../pages/Attendance/StudentMonthlyDetailsPage";
import SectionWiseDailySummaryPage from "../pages/Attendance/SectionWiseDailySummaryPage";
import ShiftWiseDailySummaryPage from "../pages/Attendance/ShiftWiseDailySummaryPage";
import StaffDateWiseReportPage from "../pages/Attendance/StaffDateWiseReportPage";
import StaffMonthlyDetailsPage from "../pages/Attendance/StaffMonthlyDetailsPage";
import StaffTimeConfigReportPage from "../pages/Attendance/StaffTimeConfigReportPage";
import StaffAttendanceTakePage from "../pages/Attendance/StaffAttendanceTakePage";
import StudentDeviceLogUploadPage from "../pages/Attendance/StudentDeviceLogUploadPage";
import StaffDeviceLogUploadPage from "../pages/Attendance/StaffDeviceLogUploadPage";
import StudentDeviceMapPage from "../pages/Attendance/StudentDeviceMapPage";
import StaffDeviceMapPage from "../pages/Attendance/StaffDeviceMapPage";
import StaffDisabledDeviceMapPage from "../pages/Attendance/StaffDisabledDeviceMapPage";
import PeriodTimeConfigPage from "../pages/Attendance/PeriodTimeConfigPage";
import StaffTimeConfigPage from "../pages/Attendance/StaffTimeConfigPage";
import StudentLeavePage from "../pages/Attendance/StudentLeavePage";
import StaffLeavePage from "../pages/Attendance/StaffLeavePage";
import WeeklyHolidayPage from "../pages/Holiday/WeeklyHolidayPage";
import OthersHolidayPage from "../pages/Holiday/OthersHolidayPage";
import ExamConfigPage from "../pages/Exam/ExamConfigPage";
import ShortCodePage from "../pages/Exam/ShortCodePage";
import ExamGradePage from "../pages/Exam/ExamGradePage";
import ExamSubjectConfigPage from "../pages/Exam/ExamSubjectConfigPage";
import ExamMarkEntryPage from "../pages/Exam/ExamMarkEntryPage";
import ExamMarkDeletePage from "../pages/Exam/ExamMarkDeletePage";
import ExamResultPage from "../pages/Exam/ExamResultPage";
import ExamMeritReportsPage from "../pages/Exam/ExamMeritReportsPage";
import ExamGradingPassFailSummaryPage from "../pages/Exam/ExamGradingPassFailSummaryPage";
import ExamMeritGeneratePage from "../pages/Exam/ExamMeritGeneratePage";
import ExamSubjectWiseGradePage from "../pages/Exam/ExamSubjectWiseGradePage";
import ExamMarkProcessPage from "../pages/Exam/ExamMarkProcessPage";
import ExamFailedSubjectDetailsPage from "../pages/Exam/ExamFailedSubjectDetailsPage";
import ExamUninputtedSubjectsPage from "../pages/Exam/ExamUninputtedSubjectsPage";
import ExamForthSubjectAssignPage from "../pages/Exam/ExamForthSubjectAssignPage";
import ExamRemarksTemplatePage from "../pages/Exam/ExamRemarksTemplatePage";
import ExamRemarksGivePage from "../pages/Exam/ExamRemarksGivePage";
import ExamTabulationSheetPage from "../pages/Exam/ExamTabulationSheetPage";
import ExamMarksheetPage from "../pages/Exam/ExamMarksheetPage";
import GrandFinalResultProcessPage from "../pages/Exam/GrandFinalResultProcessPage";
import AdmitCardInstructionPage from "../pages/Exam/AdmitCardInstructionPage";
import AdmitCardPage from "../pages/Exam/AdmitCardPage";
import SeatPlanPage from "../pages/Exam/SeatPlanPage";
import ClassRoutineImportPage from "../pages/Routine/ClassRoutineImportPage";
import ClassRoutineBuilderPage from "../pages/Routine/ClassRoutineBuilderPage";
import ExamRoutineGeneratePage from "../pages/Routine/ExamRoutineGeneratePage";
import ExamAttendanceSheetPage from "../pages/Exam/ExamAttendanceSheetPage";
import ExamMarkBlankSheetPage from "../pages/Exam/ExamMarkBlankSheetPage";
import StudentAttendanceMarksheetPage from "../pages/Attendance/StudentAttendanceMarksheetPage";
import StudentAttendanceBlankSheetPage from "../pages/Attendance/StudentAttendanceBlankSheetPage";
import GrandFinalMarkConfigurationPage from "../pages/Exam/GrandFinalMarkConfigurationPage";
import LookupSettingsPage from "../pages/Settings/LookupSettingsPage";
import TeacherSectionsPage from "../pages/Settings/TeacherSectionsPage";
import ClassConfigurationPage from "../pages/ClassConfiguration/ClassConfigurationPage";
import GroupConfigurationPage from "../pages/Settings/GroupConfigurationPage";
import SubjectConfigurationPage from "../pages/Settings/SubjectConfigurationPage";
import InstituteProfilePage from "../pages/Institute/InstituteProfilePage";
import AccountLedgerPage from "../pages/Accounts/AccountLedgerPage";
import VouchersPage from "../pages/Accounts/VouchersPage";
import AccountReportsPage from "../pages/Accounts/AccountReportsPage";
import JournalTransactionPage from "../pages/Accounts/JournalTransactionPage";
import UserWiseTransactionPage from "../pages/Accounts/UserWiseTransactionPage";
import IncomeStatementPage from "../pages/Accounts/IncomeStatementPage";
import CategorySummaryPage from "../pages/Accounts/CategorySummaryPage";
import CashBookPage from "../pages/Accounts/CashBookPage";
import BalanceSheetPage from "../pages/Accounts/BalanceSheetPage";
import CashSummaryPage from "../pages/Accounts/CashSummaryPage";
import FundsFlowPage from "../pages/Accounts/FundsFlowPage";
import IncomeSummaryPage from "../pages/Accounts/IncomeSummaryPage";
import FeeConfigPage from "../pages/Fees/FeeConfigPage";
import FeeLedgerSetupPage from "../pages/Fees/FeeLedgerSetupPage";
import FeeWaiverGrantPage from "../pages/Fees/FeeWaiverGrantPage";
import FeeWaiverListPage from "../pages/Fees/FeeWaiverListPage";
import IndividualFeeAssignPage from "../pages/Fees/IndividualFeeAssignPage";
import FeeSubHeadRemovePage from "../pages/Fees/FeeSubHeadRemovePage";
import FeeCollectionPage from "../pages/Fees/FeeCollectionPage";
import FeeInvoiceListPage from "../pages/Fees/FeeInvoiceListPage";
import FeePaidListStudentWisePage from "../pages/Fees/FeePaidListStudentWisePage";
import FeeDueInfoPage from "../pages/Fees/FeeDueInfoPage";
import FeeMonthWiseDueReportPage from "../pages/Fees/FeeMonthWiseDueReportPage";
import FeeHeadWisePaidListPage from "../pages/Fees/FeeHeadWisePaidListPage";
import FeeCollectionDateWisePage from "../pages/Fees/FeeCollectionDateWisePage";
import FeeCollectSummaryPage from "../pages/Fees/FeeCollectSummaryPage";
import FeeSectionPaidListPage from "../pages/Fees/FeeSectionPaidListPage";
import LedgerWisePaidListPage from "../pages/Fees/LedgerWisePaidListPage";
import FeeSubHeadYearlyPaidListPage from "../pages/Fees/FeeSubHeadYearlyPaidListPage";
import FeeSectionSummaryPaidListPage from "../pages/Fees/FeeSectionSummaryPaidListPage";
import FeeDateWiseSectionSummaryPage from "../pages/Fees/FeeDateWiseSectionSummaryPage";
import FeeSubCategoryDueListPage from "../pages/Fees/FeeSubCategoryDueListPage";
import PayslipPage from "../pages/Payslip/PayslipPage";
import PayslipTemplatePage from "../pages/Payslip/PayslipTemplatePage";
import PayslipSectionWisePage from "../pages/Payslip/PayslipSectionWisePage";
import SmsPage from "../pages/Sms/SmsPage";
import TestimonialPage from "../pages/Testimonial/TestimonialPage";
import TransferCertificatePage from "../pages/TransferCertificate/TransferCertificatePage";
import CertificationPage from "../pages/Certification/CertificationPage";

// Real menu urls that just jump to the already-registered generic lookup
// settings page for one resource (see settingsResources.js) —
// LookupSettingsPage takes resourceKey as a prop when it's not driven by the
// /admin/settings/:resourceKey route param.
const FeeHeadSettingsPage = () => <LookupSettingsPage resourceKey="fee-heads" />;
const FeeSubHeadSettingsPage = () => <LookupSettingsPage resourceKey="fee-subheads" />;
const FeeWaiverSettingsPage = () => <LookupSettingsPage resourceKey="fee-waivers" />;
// The other 10 "Initial Setup" core-setting resources — same generic page,
// same pattern as the 3 fee-* ones above. These were previously reachable
// only via the super-admin-fixed /admin/settings/:resourceKey route, even
// though the real production permissions table grants regular delegated
// roles (Admin, Operator, Exam Head, Accountant, ...) direct access to each
// of these exact "initial-setup-*" urls via the per-institute menu — see
// MIGRATION.md's Phase 12 audit follow-up notes for the evidence.
const AcademicYearSettingsPage = () => <LookupSettingsPage resourceKey="academic-years" />;
const ClassSettingsPage = () => <LookupSettingsPage resourceKey="classes" />;
const ShiftSettingsPage = () => <LookupSettingsPage resourceKey="shifts" />;
const SectionSettingsPage = () => <LookupSettingsPage resourceKey="sections" />;
const GroupSettingsPage = () => <LookupSettingsPage resourceKey="groups" />;
const StudentCategorySettingsPage = () => <LookupSettingsPage resourceKey="student-categories" />;
const SubjectSettingsPage = () => <LookupSettingsPage resourceKey="subjects" />;
const DesignationSettingsPage = () => <LookupSettingsPage resourceKey="designations" />;
const PeriodSettingsPage = () => <LookupSettingsPage resourceKey="periods" />;
const ExamSettingsPage = () => <LookupSettingsPage resourceKey="exams" />;

/**
 * Maps a digicampusbd page url (the same `url` values carried by
 * SidebarItem/ChildNavItem, surfaced through GET /api/menu) to the React
 * component that now implements it. Add one entry here per page as it's
 * migrated — this is the frontend half of the "New REST endpoint / New React
 * page" column in MIGRATION.md, so anything not listed here still renders
 * NotYetMigrated instead of a dead link.
 * <p>
 * Old urls that mapped to narrower single-purpose pages (e.g. digicampusbd
 * had separate "Active List" and "Inactive List" pages) are deliberately
 * consolidated onto the same new component here — same underlying data and
 * actions, fewer pages, matching the backend's own consolidation (see
 * MIGRATION.md Phase 5 notes).
 */
const pageRegistry = {
  dashboard: Dashboard,

  // Students Management > registration (real urls confirmed via GET /api/menu)
  "student-multiple-registration": StudentMultipleRegistrationPage,
  "student-multiple-registration-custom": StudentMultipleRegistrationPage,
  "student-excel-registration-with-custom-id": StudentExcelRegistrationWithIdPage,
  "student-excel-registration-without-custom-id": StudentExcelRegistrationWithoutIdPage,
  "student-migration": StudentMigrationPage,
  "student-migration-pushback": StudentMigrationPushbackPage,
  // Students Management > update (Phase 12 audit fix: these 5 real urls are
  // each a dedicated "search then edit one field-set" screen in the old app
  // — basic info, photo, address, class/section transfer, full profile —
  // all consolidated here onto the same StudentsListPage -> StudentFormPage
  // search/edit flow already built, same consolidation already used for
  // Active/Inactive List below. Confirmed via a live permissions query that
  // regular delegated roles hold 100+ real grants on every one of these.)
  "student-enable-disable": StudentsListPage,
  "disable-student-list": StudentsListPage,
  "student-basic-update": StudentsListPage,
  "student-photo-update": StudentsListPage,
  "student-address-update": StudentsListPage,
  "student-academic-info-update": StudentsListPage,
  "student-single-profile-all-update": StudentsListPage,
  "student-registration-delete": StudentsListPage,
  // Students Management > reports (StudentReportService — see MIGRATION.md's
  // Phase 12 audit: an entire 891-line/20-endpoint old-app module previously
  // undiscovered, every one of these urls carrying 100-150 real
  // non-super-admin permission grants in production). "student-info" is the
  // search/list/delete/enable-disable screen — already fully covered by
  // StudentsListPage, so mapped straight to it rather than duplicated.
  // "student-multiple-report" is only partially covered (its class+year
  // filter, via StudentReportsPage's "Class Wise" tab) — the old screen's
  // full district/thana/shift/section/category filter combination isn't
  // replicated; see MIGRATION.md.
  "student-info": StudentsListPage,
  "student-report-basic-info-list": StudentsListPage,
  "student-multiple-report": StudentReportsPage,
  "student-report-basic-info-list-class-wise": StudentReportsPage,
  "student-report-basic-info-list-group-wise": StudentReportsPage,
  "student-report-date-wise-admission": StudentReportsPage,
  "student-single-search": StudentReportsPage,
  "student-report-overview": StudentReportsPage,
  "student-report-section-wise-summary": StudentReportsPage,
  "section-wise-religion": StudentReportsPage,
  "sectionwisegender": StudentReportsPage,

  // HRM-Teacher & Staff > New Entry
  "staff-single-registration": StaffFormPage,
  "staff-multiple-registration": StaffExcelRegistrationPage,
  "staff-assign-class-teacher": ClassTeacherAssignPage,
  "staff-assign-shift-teacher": ShiftTeacherAssignPage,
  "staff-assign-subject-teacher": SubjectAssignToTeacherPage,
  "default-signature": DefaultSignaturePage,
  "class-wise-teacher-signature": ClassTeacherSignaturePage,
  // HRM-Teacher & Staff > HRM Info Update / report
  "staff-update-basic-info": StaffListPage,
  "staff-update-inactive-list": StaffListPage,
  "staff-report-basic-info-list": StaffListPage,
  "staff-multiple-update": StaffMultipleUpdatePage,
  // HRM-Teacher & Staff > Configure (Phase 12 audit fix: real url, real
  // menu label "Department Create" — misleadingly named in the old app,
  // but its own ajax calls (`/teacher/section/*`) confirm it's the same
  // CoreSettingTeacherSection feature already built as TeacherSectionsPage,
  // previously reachable only via the super-admin-fixed
  // /admin/settings/teacher-sections route. 19 real non-super-admin grants.)
  "teacher-section": TeacherSectionsPage,

  // basic setting > Institute info Update (Phase 12 audit fix: same
  // pattern as teacher-section above — InstituteProfilePage already built,
  // previously reachable only via the super-admin-fixed
  // /admin/institute-profile route, but 93 real non-super-admin grants
  // exist on this exact url in production.)
  "institute-update": InstituteProfilePage,

  // Student Attendance (Phase 6)
  "student-attendance-input": StudentAttendanceTakePage,
  "student-attendance-update": StudentAttendanceTakePage,
  "student-attendance-report-daily-section": StudentDailySectionReportPage,
  "student-attendance-report-monthly-section-summary": StudentMonthlySummaryPage,
  "student-attendance-report-monthly-section-details": StudentMonthlyDetailsPage,
  "student-attendance-report-section-wise-daily-summary": SectionWiseDailySummaryPage,
  "student-attendance-report-shift-wise-daily-summary": ShiftWiseDailySummaryPage,
  "student-attendance-machine-input": StudentDeviceLogUploadPage,
  "student-device-id-mapping": StudentDeviceMapPage,
  "student-attendance-period-time-configuration": PeriodTimeConfigPage,
  "student-leave-input": StudentLeavePage,

  // HRM Attendance (Phase 6)
  "staff-attendance-input": StaffAttendanceTakePage,
  "staff-attendance-update": StaffAttendanceTakePage,
  "staff-attendance-file-upload": StaffDeviceLogUploadPage,
  "staff-attendance-machine-map": StaffDeviceMapPage,
  "staff-attendance-disabled-machine-map": StaffDisabledDeviceMapPage,
  "staff-attendance-time-configuration": StaffTimeConfigPage,
  "staff-attendance-report-date-wise": StaffDateWiseReportPage,
  "staff-attendance-report-monthly-details": StaffMonthlyDetailsPage,
  "staff-attendance-time-configuration-report": StaffTimeConfigReportPage,
  "hr-leave-input": StaffLeavePage,

  // Holiday Management (Phase 6)
  "weekly-holiday": WeeklyHolidayPage,
  "others-holiday": OthersHolidayPage,

  // Result Management > exam (Phase 7 — core config/marks/grades/result pipeline)
  "exam-configuration": ExamConfigPage,
  "exam-shortcode": ShortCodePage,
  "exam-grade": ExamGradePage,
  "exam-grade-bangla": ExamGradePage,
  "initial-setup-subject-configuration": SubjectConfigurationPage,
  "exam-mark-configuration": ExamSubjectConfigPage,
  "exam-mark-input": ExamMarkEntryPage,
  "exam-mark-update": ExamMarkEntryPage,
  "exam-mark-delete": ExamMarkDeletePage,
  "exam-result-process-general": ExamResultPage,
  "exam-merit-position-generate": ExamMeritGeneratePage,
  "exam-report-subject-wise-grading-summary": ExamSubjectWiseGradePage,
  "exam-report-class-merit-position": ExamMeritReportsPage,
  "exam-report-section-merit-position": ExamMeritReportsPage,
  "exam-report-group-merit-position": ExamMeritReportsPage,
  "exam-report-shift-merit-position": ExamMeritReportsPage,
  "exam-report-class-failed-list": ExamMeritReportsPage,
  "exam-report-section-result": ExamMeritReportsPage,
  "exam-report-section-wise-grading-summary": ExamGradingPassFailSummaryPage,
  "exam-result-process-mark": ExamMarkProcessPage,
  "exam-report-section-wise-pass-fail-summary": ExamGradingPassFailSummaryPage,
  "exam-report-section-failed-list": ExamFailedSubjectDetailsPage,
  "exam-report-group-failed-list": ExamFailedSubjectDetailsPage,
  "exam-report-section-wise-un-inputted-subjects": ExamUninputtedSubjectsPage,
  "exam-report-fail-details": ExamFailedSubjectDetailsPage,
  "exam-forth-subject-assign": ExamForthSubjectAssignPage,
  "exam-forth-subject-assigned-list": ExamForthSubjectAssignPage,
  "exam-remarks-template": ExamRemarksTemplatePage,
  "exam-remarks-give": ExamRemarksGivePage,
  "exam-general-tabulation-sheet": ExamTabulationSheetPage,
  "exam-general-tabulation-sheet-download": ExamTabulationSheetPage,
  "exam-average-tabulation-sheet": ExamTabulationSheetPage,
  "exam-bottom-tabulation-sheet": ExamTabulationSheetPage,
  "exam-general-short-tabulation-sheet-download": ExamTabulationSheetPage,
  "exam-general-marksheet-download": ExamMarksheetPage,
  "exam-general-marksheet-print": ExamMarksheetPage,
  "exam-result-process-grand-final": GrandFinalResultProcessPage,
  // Documented simplification: the old app's Grand Final tabulation sheet is
  // a fancier multi-exam-column view (every component exam + the Grand Final
  // side by side); reusing the single-exam ExamTabulationSheetPage/
  // ExamMarksheetPage here instead, pointed at the Grand Final's own exam
  // config — same "browser-printable, reuse the existing generic page"
  // pattern already used for every other Jasper-only marksheet/tabulation
  // url in this migration.
  "exam-grand-final-tabulation-sheet": ExamTabulationSheetPage,
  "exam-grand-final-marksheet-download": ExamMarksheetPage,
  "admit-card-instruction": AdmitCardInstructionPage,
  "admit-card-sear-plan-download": AdmitCardPage,
  "admit-card-with-exam-routine": AdmitCardPage,
  "seat-plan-download": SeatPlanPage,
  "class-routine": ClassRoutineImportPage,
  "create-class-routine": ClassRoutineBuilderPage,
  "class-routine-view": ClassRoutineBuilderPage,
  "update-class-routine": ClassRoutineBuilderPage,
  "exam-routine-create": ExamRoutineGeneratePage,
  "exam-routine-create-list": ExamRoutineGeneratePage,
  "exam-attendance-sheet": ExamAttendanceSheetPage,
  "exam-mark-input-multiple-blank-sheet": ExamMarkBlankSheetPage,
  "student-attendance-for-marksheet": StudentAttendanceMarksheetPage,
  "student-attendance-list-for-marksheet": StudentAttendanceMarksheetPage,
  "student-attendance-blank-sheet": StudentAttendanceBlankSheetPage,
  "exam-grandfinal-mark-configuration": GrandFinalMarkConfigurationPage,

  // Account Management (generalaccount, Phase 8) — real urls confirmed via a live query
  // against the real sidebar_item/nav_item/child_nav_item tables (same method used in
  // every prior phase). The old app's ~9 report-variant urls beyond trial balance and
  // ledger book are not mapped — see MIGRATION.md Phase 8 FeeReportService note.
  "general-accounts-ledger-list": AccountLedgerPage,
  "general-accounts-contra": VouchersPage,
  "general-accounts-journal": VouchersPage,
  "general-accounts-receive": VouchersPage,
  "general-accounts-payment": VouchersPage,
  "voucher-list": VouchersPage,
  "general-accounts-trn-delete": VouchersPage,
  "general-accounts-report-trial-balance": AccountReportsPage,
  "general-accounts-report-ledgerSummary": AccountReportsPage,
  "general-accounts-report-ledger-book": AccountReportsPage,
  "general-accounts-report-journal": JournalTransactionPage,
  "general-accounts-report-user-wise": UserWiseTransactionPage,
  "general-accounts-report-income-statement": IncomeStatementPage,
  "general-accounts-report-category-list-summary": CategorySummaryPage,
  "general-accounts-report-cash-book": CashBookPage,
  "general-accounts-report-balance-sheet": BalanceSheetPage,
  "general-accounts-report-cash-summary": CashSummaryPage,
  "general-accounts-report-funds-flow": FundsFlowPage,
  "general-accounts-report-income-summary": IncomeSummaryPage,
  "general-accounts-auto-fee-collection": LedgerWisePaidListPage,
  "fee-report-sub-head-yearly-paid-list": FeeSubHeadYearlyPaidListPage,
  "fee-report-section-summary-paid-list": FeeSectionSummaryPaidListPage,
  "fee-report-date-wise-section-summary": FeeDateWiseSectionSummaryPage,
  "fee-report-sub-category-due-list": FeeSubCategoryDueListPage,

  // Fees Management (studentaccounts, Phase 8)
  "initial-setup-fee-head": FeeHeadSettingsPage,
  "initial-setup-fee-sub-head": FeeSubHeadSettingsPage,
  "initial-setup-fee-waiver": FeeWaiverSettingsPage,

  // Initial Setup — the rest of the core-setting lookup resources (Phase 12
  // audit fix: confirmed via a live query against permissions/child_nav_item
  // that non-super-admin roles hold real grants for every one of these urls
  // in production; each had a working page already, just unreachable via the
  // real per-institute menu until this fix — see MIGRATION.md).
  "initial-setup-academic-year": AcademicYearSettingsPage,
  "initial-setup-class": ClassSettingsPage,
  "initial-setup-shift": ShiftSettingsPage,
  "initial-setup-section": SectionSettingsPage,
  "initial-setup-group": GroupSettingsPage,
  "initial-setup-student-category": StudentCategorySettingsPage,
  "initial-setup-subject": SubjectSettingsPage,
  "initial-setup-designation": DesignationSettingsPage,
  "initial-setup-period": PeriodSettingsPage,
  "initial-setup-exam": ExamSettingsPage,
  "initial-setup-class-configuration": ClassConfigurationPage,
  "initial-setup-group-configuration": GroupConfigurationPage,
  "fee-subhead-configuration": FeeConfigPage,
  "fee-amount-configuration": FeeConfigPage,
  "multiple-fee-amount-configuration": FeeConfigPage,
  "fee-subhead-time-configuration": FeeConfigPage,
  "fee-head-ledger-configuration": FeeLedgerSetupPage,
  "fee-fine-ledger-configuration": FeeLedgerSetupPage,
  "student-account-auto-ledger-setup": FeeLedgerSetupPage,
  "fee-waiver-configuration": FeeWaiverGrantPage,
  "fee-waiver-configuration-list": FeeWaiverListPage,
  "student-individual-fee-asign": IndividualFeeAssignPage,
  "fee-subHead-remove": FeeSubHeadRemovePage,
  "fee-subHead-removeList": FeeSubHeadRemovePage,
  "fee-collection-manual": FeeCollectionPage,
  "section-roll-wise-fee-collection": FeeCollectionPage,
  "student-accounts-trn-delete": FeeInvoiceListPage,
  "fee-report-all-paid-list": FeeInvoiceListPage,
  "fee-money-receipt-template": FeeInvoiceListPage,
  // Real, genuinely different report from the 3 above (a per-student,
  // per-fee-subhead pivot table, not another paid-invoice-list view) — found
  // missing while sweeping Fee Management, built into its own page (see
  // MIGRATION.md).
  "fee-report-yearly-paid-list": FeePaidListStudentWisePage,
  // "Fee Due Info" — real menu URL confirmed via the live menu table (child_nav_item
  // id 237, "Fee Due Info") to be the one genuinely staff-reachable due report; the
  // page previously wired here (FeeDueReportPage, dueList) was real code but had no
  // real menu entry of its own anywhere in this institute's actual menu data — see
  // FeeReportService's javadoc and MIGRATION.md.
  "fee-report-student-due-details": FeeDueInfoPage,
  "fee-report-month-wise-student-payable-due-list": FeeMonthWiseDueReportPage,
  "fee-report-feehead-month-wise-paid-list": FeeHeadWisePaidListPage,
  "fee-report-all-class-date-to-date": FeeCollectionDateWisePage,
  "fee-report-date-to-date-head-collection": FeeCollectSummaryPage,
  "fee-report-section-paid-list": FeeSectionPaidListPage,

  // Payslip management (Phase 8; payslip-template built post-launch — see
  // MIGRATION.md's Known follow-ups: real url, 98 non-super-admin permission
  // grants in production, previously only a hardcoded entity/repository
  // with no controller/service/page)
  "payslip-create-single": PayslipPage,
  "payslip-create-bacth": PayslipPage,
  "payslip-create-bacth-section-wise": PayslipPage,
  "payslip-collect": PayslipPage,
  // Real child_nav_item.url has a literal embedded space
  // ("payslip-collect- section-wise") in production, while the old app's
  // own template file and internal links use the space-free
  // "payslip-collect-section-wise" — registering both to the same
  // dedicated section-wise page; this generic PayslipPage was only ever a
  // placeholder fallback and implements no section-wise filtering.
  "payslip-collect- section-wise": PayslipSectionWisePage,
  "payslip-collect-section-wise": PayslipSectionWisePage,
  "payslip-collect-class-wise": PayslipPage,
  "payslip-template": PayslipTemplatePage,

  // SMS management (Phase 9) — all 16 real "SMS management" sidebar urls plus
  // Student Attendance's own "attendance-sms-template" url fold onto one
  // consolidated SmsPage (Send / Templates / Balance / Reports tabs). See
  // MIGRATION.md Phase 9 notes for the per-url mapping rationale.
  "sms-template": SmsPage,
  "sms-balance-purchase": SmsPage,
  "sms-report-general-view": SmsPage,
  "sms-report-staff-view": SmsPage,
  "sms-report-student-view": SmsPage,
  "sms-report-purchase-history": SmsPage,
  "send-sms-to-student-classwise": SmsPage,
  "sms-send-student-section-wise": SmsPage,
  "send-sms-to-student-institutewise": SmsPage,
  "send-sms-to-student-duewise": SmsPage,
  "send-sms-to-student-examresult": SmsPage,
  "send-sms-to-student-exam-result-subject-wise": SmsPage,
  "sms-send-to-staff": SmsPage,
  "sms-send-dynamic": SmsPage,
  "sms-send-dynamic-bulk": SmsPage,
  "send-sms-to-student-absent-wise": SmsPage,
  "attendance-sms-template": SmsPage,

  // Documents (Phase 11) — real, heavily-used urls confirmed via the live
  // sidebar_item/child_nav_item tables (2,481 real testimonials, 433 real
  // transfer certificates, 1,339 real certifications already issued).
  "testimonial-add": TestimonialPage,
  "testimonial-download": TestimonialPage,
  "tc-add": TransferCertificatePage,
  "tc-download": TransferCertificatePage,
  "student-report-for-certification-download": CertificationPage,
};

export default pageRegistry;
